import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;
const DOT = { operational: '#10b981', warning: '#f59e0b', degraded: '#f97316', critical: '#ef4444', unknown: '#94a3b8', unmonitored: '#94a3b8' };

// Compact, always-on platform health pill for the sidebar (admins only).
export default function SystemHealthBadge({ onClick }) {
  const { token, user } = useAuth();
  const [state, setState] = useState(null);
  const isAdmin = user && (user.is_master || user.role === 'admin');

  useEffect(() => {
    if (!isAdmin || !token) return;
    let on = true;
    const load = async () => {
      try { const r = await axios.get(`${API}/api/diagnostics/health-badge`, { headers: { Authorization: `Bearer ${token}` } }); if (on) setState(r.data); }
      catch { /* keep last state */ }
    };
    load();
    const id = setInterval(() => { if (!document.hidden) load(); }, 30000);
    return () => { on = false; clearInterval(id); };
  }, [isAdmin, token]);

  if (!isAdmin || !state) return null;
  const color = DOT[state.tone] || DOT.unknown;
  return (
    <button type="button" onClick={onClick} data-testid="sidebar-health-badge"
      className="w-full flex items-center gap-2 px-3 py-2 rounded-xl hover:bg-slate-100 transition-colors group">
      <span className="relative inline-flex h-2 w-2 shrink-0">
        {state.tone === 'operational' && <span className="absolute inline-flex h-full w-full rounded-full opacity-60 animate-ping" style={{ background: color }} />}
        <span className="relative inline-flex rounded-full h-2 w-2" style={{ background: color }} />
      </span>
      <span className="text-[11.5px] font-semibold text-slate-600 group-hover:text-slate-900 truncate">{state.label}</span>
    </button>
  );
}
